import React, { useContext, useEffect, useState } from "react";
import "./CircleInfo.scss";
import CreateCircleInfo from "./CreateCircleInfo";
import { collection, getDocs, orderBy, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MemberContext } from "../Contexts/MemberContext";

const CircleInfo = () => {
  const [content, setContent] = useState("");
  const { currentUserInfo } = useContext(MemberContext);
  const useradministrator = currentUserInfo?.administrator;
  const [postShow, setPostShow] = useState(false);
  const navigate = useNavigate();
  const { eventState } = useParams();
  const location = useLocation();
  const { pagestate } = location.state || {};
  const [circleInfoList, setCircleInfoList] = useState([
    {
      id: "",
      eventdate: "",
      title: "",
      content: "",
      linkUrl: "",
      created_at: new Date(),
      updated_at: new Date(),
    },
  ]);

  // if (pagestate && pagestate === "create") {
  //   setPostShow(false);
  // }
  const matsu = pagestate && pagestate;
  console.log(useradministrator);

  useEffect(() => {
    const fetchCircleInfo = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "circleinfo"));
        const infoList = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            eventdate:
              data.eventdate instanceof Timestamp
                ? data.eventdate.toDate().toLocaleString()
                : data.eventdate, // すでに string ならそのまま

            created_at:
              data.created_at instanceof Timestamp
                ? data.created_at.toDate().toLocaleString()
                : data.created_at, // すでに string ならそのまま

            updated_at:
              data.updated_at instanceof Timestamp
                ? data.updated_at.toDate().toLocaleString()
                : data.updated_at, // すでに string ならそのまま
          };
        });

        // eventdate を基に降順でソート
        const sortedInfoList = infoList.sort((b, a) => {
          // eventdate を Date 型に変換して降順に並べ替え
          return new Date(b.eventdate) - new Date(a.eventdate);
        });

        setCircleInfoList(sortedInfoList);
      } catch (error) {
        console.error("データ取得エラー:", error);
      }
    };

    fetchCircleInfo();
  }, [postShow, pagestate]);

  useEffect(() => {
    if (pagestate === "create") {
      setPostShow(false);
    }
  }, [pagestate]);

  const Content = () => {
    console.log("なあんだ");
  };

  const handleSubmit = (id) => {
    console.log(`投稿するID: ${id}`);
  };

  const handleInfoShow = () => {
    setPostShow(!postShow);
  };

  console.log(circleInfoList);
  return (
    <>
      <div className="circleinfo-container">
        {/* postShow が true の場合のみ CreateCircleInfo を表示 */}
        {postShow && (
          <div className="circleinfo-add-show">
            <CreateCircleInfo setPostShow={setPostShow} />
          </div>
        )}

        {/* postShow が false のときのみ他の要素を表示 */}
        {!postShow && (
          <div className="circleinfo-content">
            <div className="circleinfo-content-title">
              <h1>サークルの歩み</h1>
              {useradministrator && (
                <div className="circleInfo-add">
                  <button
                    className="circleInfo-add-button"
                    onClick={handleInfoShow}
                  >
                    <span className="circleInfo-add-button-text">追加</span>
                  </button>
                </div>
              )}
            </div>
            <div className="circleinfo-content-content">
              <table>
                <thead>
                  <tr>
                    <th>
                      {" "}
                      <span className="circleinfo_filed_table_text">
                        年　月{" "}
                      </span>
                    </th>
                    <th>
                      {" "}
                      <span className="circleinfo_filed_table_text">
                        タイトル{" "}
                      </span>
                    </th>
                    <th>
                      {" "}
                      <span className="circleinfo_filed_table_text">内容 </span>
                    </th>
                    <th>
                      {" "}
                      <span className="circleinfo_filed_table_text">Link </span>
                    </th>
                    {useradministrator && (
                      <th>
                        {" "}
                        <span className="circleinfo_filed_table_text">
                          投稿{" "}
                        </span>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {circleInfoList.map((circle) => (
                    <tr className="circleinfo_filed" key={circle.id}>
                      <td>
                        <span className="circleinfo_filed_table_text">
                          {circle.eventdatestring}
                        </span>
                      </td>
                      <td>
                        {" "}
                        <span className="circleinfo_filed_table_text_left">
                          {circle.title}{" "}
                        </span>
                      </td>
                      <td>
                        {" "}
                        <span className="circleinfo_filed_table_text_left">
                          {circle.content}{" "}
                        </span>
                      </td>

                      <td>
                        {" "}
                        {circle.linkUrl ? (
                          <span className="circleinfo_filed_table_text_left">
                            <a
                              href={circle.linkUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="circleinfo_filed_table_text_left"
                            >
                              Link
                            </a>
                          </span>
                        ) : (
                          ""
                        )}{" "}
                      </td>
                      {useradministrator && (
                        <td>
                          <button
                            className="circleinfo-edit-button"
                            onClick={() => {
                              navigate(`/createcircleinfo/${circle.id}/edit`, {
                                state: { circleInfoList: circleInfoList },
                              });
                            }}
                          >
                            編集
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CircleInfo;
